import Swiper, { Navigation } from 'swiper';
import 'swiper/css';

export default class MemberDetailSlider {
  constructor(elem, opts) {
    this.elm = elem
    this.breakpoint = 768
    this.sliderFlg = false

    this.eventBinds()
  }

  eventBinds() {
    this.sliderFlg = true
    this.addSliderControl()
  }

  addSliderControl(){
    this.slider = new Swiper(this.elm, {
      modules: [ Navigation ],
      slidesPerView: 1,
      spaceBetween: 35,
      freeMode: true,
      centeredSlides: false,
      navigation: {
        nextEl: '.swiper__member__detail__btn.is-next',
        prevEl: '.swiper__member__detail__btn.is-prev',
      },
      breakpoints: {
        // スライドの表示枚数：500px以上の場合
        769: {
          slidesPerView: 4,
        }
      }
    });
  }

  removeSliderControl(){
    this.slider.destroy();
    this.slider = undefined;
  }
}